/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

const MANAGEMENT_REPORT_BASE_LINK = '/admin/management-reports'

export function getManagementReportGenerateLink () {
  return `${MANAGEMENT_REPORT_BASE_LINK}/generate`
}

export function getManagementReportListLink () {
  return MANAGEMENT_REPORT_BASE_LINK
}

export function getManagementReportViewLink (params?: Record<string, unknown>) {
  return `${MANAGEMENT_REPORT_BASE_LINK}/view?${stringify(params)}`
}
